// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-loading-app {
  --catalog-loader-navy: #10284a;
  --catalog-loader-blue: #1759ad;
  --catalog-loader-ink: #14253d;
  --catalog-loader-muted: #64748b;
  --catalog-loader-soft: #f5f7fb;
  width: 100%;
  min-width: 0;
  color: var(--catalog-loader-ink);
  background: var(--catalog-loader-soft);
  font-family: Manrope, Inter, ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-synthesis: none;
}

.catalog-loading-app,
.catalog-loading-app *,
.catalog-loading-app *::before,
.catalog-loading-app *::after {
  box-sizing: border-box;
}

.catalog-loading-app--standalone {
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
}

.catalog-loading-app--embedded {
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.catalog-full-loader {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0;
  padding: 3rem 1.25rem;
  color: var(--catalog-loader-ink);
  background:
    radial-gradient(circle at 50% 38%, rgba(23, 89, 173, 0.09), transparent 18rem),
    var(--catalog-loader-soft);
  text-align: center;
}

.catalog-loading-app--embedded .catalog-full-loader {
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 38%, rgba(23, 89, 173, 0.075), transparent 18rem),
    #ffffff;
}

.catalog-full-loader__mark {
  width: 5rem;
  height: 5rem;
  display: grid;
  place-items: center;
  color: var(--catalog-loader-blue);
  border: 1px solid #cbdcf2;
  border-radius: 1.5rem;
  background: #eff6ff;
  box-shadow: 0 14px 30px rgba(15, 40, 74, 0.1);
  transform: rotate(-5deg);
}

.catalog-full-loader__mark svg {
  width: 2.35rem;
  height: 2.35rem;
  fill: currentColor;
  stroke: none;
}

.catalog-full-loader h1 {
  margin: 1.25rem 0 0.55rem;
  color: var(--catalog-loader-navy);
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 700;
  letter-spacing: -0.035em;
}

.catalog-full-loader p {
  max-width: 34rem;
  margin: 0;
  color: var(--catalog-loader-muted);
  font-weight: 650;
  line-height: 1.5;
}

.catalog-full-loader__rail {
  width: min(18rem, 70vw);
  height: 0.25rem;
  overflow: hidden;
  margin-top: 1.5rem;
  border-radius: 999px;
  background: #dce4ef;
}

.catalog-full-loader__retry {
  margin-top: 1.5rem;
  padding: 0.75rem 1.25rem;
  border: 0;
  border-radius: 0.5rem;
  background: var(--catalog-loader-blue);
  color: #ffffff;
  font: inherit;
  cursor: pointer;
}

.catalog-full-loader__retry:focus-visible {
  outline: 3px solid var(--catalog-loader-navy);
  outline-offset: 3px;
}

.catalog-full-loader__rail > span {
  width: 42%;
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--catalog-loader-blue), #4f8dd7);
  animation: catalog-full-loader-progress 1.25s ease-in-out infinite alternate;
}

@keyframes catalog-full-loader-progress {
  from { transform: translateX(-105%); }
  to { transform: translateX(243%); }
}

@media (prefers-reduced-motion: reduce) {
  .catalog-full-loader__rail > span {
    animation: none;
    margin: 0 auto;
    opacity: 0.62;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CatalogLoadingState.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,sCAAsC;EACtC;8CAC4C;EAC5C,oBAAoB;AACtB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,gCAAgC;EAChC;;8BAE4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB;;WAES;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,qBAAqB;EACrB,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,uEAAuE;EACvE,4EAA4E;AAC9E;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".catalog-loading-app {\n  --catalog-loader-navy: #10284a;\n  --catalog-loader-blue: #1759ad;\n  --catalog-loader-ink: #14253d;\n  --catalog-loader-muted: #64748b;\n  --catalog-loader-soft: #f5f7fb;\n  width: 100%;\n  min-width: 0;\n  color: var(--catalog-loader-ink);\n  background: var(--catalog-loader-soft);\n  font-family: Manrope, Inter, ui-sans-serif, system-ui, -apple-system,\n    BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  font-synthesis: none;\n}\n\n.catalog-loading-app,\n.catalog-loading-app *,\n.catalog-loading-app *::before,\n.catalog-loading-app *::after {\n  box-sizing: border-box;\n}\n\n.catalog-loading-app--standalone {\n  height: 100vh;\n  height: 100dvh;\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow: hidden;\n}\n\n.catalog-loading-app--embedded {\n  height: 100%;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.catalog-full-loader {\n  width: 100%;\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0;\n  padding: 3rem 1.25rem;\n  color: var(--catalog-loader-ink);\n  background:\n    radial-gradient(circle at 50% 38%, rgba(23, 89, 173, 0.09), transparent 18rem),\n    var(--catalog-loader-soft);\n  text-align: center;\n}\n\n.catalog-loading-app--embedded .catalog-full-loader {\n  height: 100%;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at 50% 38%, rgba(23, 89, 173, 0.075), transparent 18rem),\n    #ffffff;\n}\n\n.catalog-full-loader__mark {\n  width: 5rem;\n  height: 5rem;\n  display: grid;\n  place-items: center;\n  color: var(--catalog-loader-blue);\n  border: 1px solid #cbdcf2;\n  border-radius: 1.5rem;\n  background: #eff6ff;\n  box-shadow: 0 14px 30px rgba(15, 40, 74, 0.1);\n  transform: rotate(-5deg);\n}\n\n.catalog-full-loader__mark svg {\n  width: 2.35rem;\n  height: 2.35rem;\n  fill: currentColor;\n  stroke: none;\n}\n\n.catalog-full-loader h1 {\n  margin: 1.25rem 0 0.55rem;\n  color: var(--catalog-loader-navy);\n  font-size: clamp(1.8rem, 4vw, 2.8rem);\n  font-weight: 700;\n  letter-spacing: -0.035em;\n}\n\n.catalog-full-loader p {\n  max-width: 34rem;\n  margin: 0;\n  color: var(--catalog-loader-muted);\n  font-weight: 650;\n  line-height: 1.5;\n}\n\n.catalog-full-loader__rail {\n  width: min(18rem, 70vw);\n  height: 0.25rem;\n  overflow: hidden;\n  margin-top: 1.5rem;\n  border-radius: 999px;\n  background: #dce4ef;\n}\n\n.catalog-full-loader__retry {\n  margin-top: 1.5rem;\n  padding: 0.75rem 1.25rem;\n  border: 0;\n  border-radius: 0.5rem;\n  background: var(--catalog-loader-blue);\n  color: #ffffff;\n  font: inherit;\n  cursor: pointer;\n}\n\n.catalog-full-loader__retry:focus-visible {\n  outline: 3px solid var(--catalog-loader-navy);\n  outline-offset: 3px;\n}\n\n.catalog-full-loader__rail > span {\n  width: 42%;\n  height: 100%;\n  display: block;\n  border-radius: inherit;\n  background: linear-gradient(90deg, var(--catalog-loader-blue), #4f8dd7);\n  animation: catalog-full-loader-progress 1.25s ease-in-out infinite alternate;\n}\n\n@keyframes catalog-full-loader-progress {\n  from { transform: translateX(-105%); }\n  to { transform: translateX(243%); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .catalog-full-loader__rail > span {\n    animation: none;\n    margin: 0 auto;\n    opacity: 0.62;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
